import { render, staticRenderFns } from "./bron_types.vue?vue&type=template&id=7149b1e0&scoped=true"
import script from "./bron_types.vue?vue&type=script&lang=js"
export * from "./bron_types.vue?vue&type=script&lang=js"
import style0 from "./bron_types.vue?vue&type=style&index=0&id=7149b1e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7149b1e0",
  null
  
)

export default component.exports